import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './App.css';
import Navigation from './components/Navigation'



function App() {
  return (<div className="flex-wrapper">
    <Navigation />
    <div className="footer">
      &#169; 2021 Space Castle Games
    </div>
  </div>
  );
}

export default App;

